<nav id="menu-services" trapFocus (keyup.escape)="close()">
    <a id="genetic-monitoring-link" [href]="geneticMonitoringUrl" target="_blank" autofocus>
        <img
            src="assets/images/app-icons/genetic-monitoring-icon.svg"
            alt="genetic-monitoring-icon"
            id="genetic-monitoring-icon" />
        <label for="genetic-monitoring-icon" id="genetic-monitoring-label">Genetic Monitoring</label>
    </a>
    <a id="microbiome-link" [href]="microbiomeUrl" target="_blank">
        <img src="assets/images/app-icons/microbiome-icon.svg" alt="microbiome-icon" id="microbiome-icon" />
        <label for="microbiome-icon" id="microbiome-label">Microbiome</label>
    </a>
    <a id="colony-and-ami-link" [href]="colonyUrl" target="_blank">
        <img src="assets/images/app-icons/colony-icon.svg" alt="colony-and-ami-icon" id="colony-and-ami-icon" />
        <label for="colony-and-ami-icon" id="colony-and-ami-label">Colony+AMI</label>
    </a>
    <a id="tag-center-link" [href]="tagCenterUrl" target="_blank">
        <img src="assets/images/app-icons/tag-center-icon.svg" alt="tag-center-icon" id="tag-center-icon" />
        <label for="colony-and-ami-icon" id="tag-center-label">TAGCenter</label>
    </a>
</nav>
